import { Component } from '@angular/core';
import { SettingsService } from '@app/core/settings/settings.service';
import { map } from 'rxjs/operators';
import { Settings } from '@app/core/_models/settings';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { LoyaltyClubHeaderComponent } from '@app/shared/components/loyalty-club-header/loyalty-club-header.component';
import { AsyncPipe } from '@angular/common';
import { LoginComponent } from '@app/+login/views/entry/login/login.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-entry',
  templateUrl: './entry.component.html',
  imports: [
    TopNavbarComponent,
    LoyaltyClubHeaderComponent,
    AsyncPipe,
    LoginComponent,
    TranslatePipe,
    LoyaltyClubFooterComponent,
    RouterOutlet,
  ],
})
export class EntryComponent {
  public settings$ = this.settingsService.getSettingsOnce();
  public isHybridLogin$ = this.settings$.pipe(
    map((settings: Settings) => settings.isHybridLoginFlow()),
  );

  constructor(private settingsService: SettingsService) {}
}
